<template>
  <div class="page">
    <div class="weui-msg">
      <div class="weui-msg__icon-area">
        <i class="weui-icon-waiting weui-icon_msg"></i>
      </div>
      <div class="weui-msg__text-area">
        <h2 class="weui-msg__title">下单成功</h2>
        <p class="weui-msg__desc">
          请在30分钟内完成支付，否则该预约单将自动作废，感谢您对校圆通的支持。
        </p>
      </div>
      <div class="weui-msg__opr-area">
        <p class="weui-btn-area">
          <a href="javascript:;" class="weui-btn weui-btn_primary" @click="pay">立即支付</a>
          <a href="javascript:;" class="weui-btn weui-btn_default" @click="detail">查看详情</a>
        </p>
      </div>
      <div class="weui-msg__extra-area">
        <div class="weui-footer">
          <p class="weui-footer__links">
            <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
          </p>
          <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import moment from "moment";
const wx = require("weixin-js-sdk");

export default {
  data() {
    return {
      paotuiId: "",
      encodeToken: "",
      token: "",
      year: moment().format("YYYY")
    };
  },
  created() {
    this.paotuiId = this.$route.params.paotuiId;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    let url = window.location.href;
    let params = {
      url: url
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then(res => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = ["chooseWXPay"];
        wx.config(jsConfig);
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    pay() {
      let that = this;
      axios
        .get("/api/paotuiOrder/getById/" + this.paotuiId)
        .then(res => {
          if (res.data.success) {
            let prepayId = res.data.data.prepayId;
            let orderType = res.data.data.type;
            // 获取支付签名
            let params = {
              package: prepayId
            };
            axios
              .get("/api/wx/paysign", { params })
              .then(response => {
                if (response.data.success) {
                  let payConfig = response.data.data;
                  payConfig.success = function(res) {
                    // 直接跳转回我发布的进行中跑腿列表
                    that.$router.push("/robbingList/1/ing/" + that.encodeToken);
                  };
                  wx.chooseWXPay(payConfig);
                } else {
                  weui.alert("获取支付签名失败");
                }
              })
              .catch(error => {
                weui.alert("获取支付签名失败");
              });
          } else {
            console.log(res.data.message);
            weui.alert("获取订单信息失败");
          }
        })
        .catch(err => {
          console.log(err);
          weui.alert("获取订单信息失败");
        });
    },
    detail() {
      this.$router.push("/robbingList/1/ing/" + this.encodeToken);
    }
  }
};
</script>

<style scoped>
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/OrderSuccess.vue